// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"01a495b9","620":"0c03d10b"}[chunkId] + ".js";
};